<template>
  <div class="page-chat">
    <chat-header class="header" ref="headerRef" />
    <chat-body class="body" ref="bodyRef" :style="bodyStyle" />
    <chat-footer class="footer" ref="footerRef" @openMenu="openMenu" />
    <image-previewer />
  </div>
</template>

<script>
import ChatHeader from './components/ChatHeader.vue'
import ChatBody from './components/ChatBody.vue'
import ChatFooter from './components/ChatFooter.vue'
import ImagePreviewer from './components/image-previewer.vue'
import { mapState } from 'vuex'

export default {
  name: 'PageChat',
  props: {
    userID: {
      require: true,
      type: String
    }
  },
  components: {
    ChatHeader,
    ChatBody,
    ChatFooter,
    ImagePreviewer
  },
  data () {
    return {
      headerH: 0,
      footerH: 0
    }
  },
  computed: {
    ...mapState('chat', ['isSDKReady']),
    bodyStyle () {
      return {
        height: `calc(100% - ${this.headerH}px - ${this.footerH}px)`
      }
    }
  },
  watch: {
    isSDKReady () {
      if (this.isSDKReady && this.userID) {
        this.getMsgContent()
      }
    }
  },
  created () {
    this.getHeight()
    if (this.isSDKReady && this.userID) {
      this.getMsgContent()
    }
  },
  methods: {
    getHeight () {
      this.$nextTick(() => {
        this.headerH = this.$refs.headerRef.$el.clientHeight
        this.footerH = this.$refs.footerRef.$el.clientHeight
      })
    },
    openMenu () {
      this.$nextTick(() => {
        this.footerH = this.$refs.footerRef.$el.clientHeight
      })
    },
    async getMsgContent () {
      const res = await this.tim.getConversationProfile(this.userID)
      const { code, data } = res
      if (code === 0) {
        this.messageObj = data.conversation
        this.$store.commit('chat/updateCurrentConversation', this.messageObj)
        this.$store.dispatch('chat/getMessageList', this.userID)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-chat {
  height: 100%;
  background-color: #efefef;
  position: relative;

  // .header {
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  // }
  .body {
    // height: 100%;
    box-sizing: border-box;
  }
  // .footer {
  //   position: absolute;
  //   left: 0;
  //   bottom: 0;
  // }
}
</style>
